import { render } from "./ActionItems.vue?vue&type=template&id=13bd4c28&scoped=true"
import script from "./ActionItems.vue?vue&type=script&lang=js"
export * from "./ActionItems.vue?vue&type=script&lang=js"

import "./ActionItems.vue?vue&type=style&index=0&id=13bd4c28&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13bd4c28"]])

export default __exports__